import { useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from 'reactstrap';

const DeleteContractorConfirmationModal = ({
  open,
  onClose,
  onDelete,
  contractor,
}) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onDelete();
      onClose();
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const companyDisplay = contractor?.company_name
    ? `"${contractor.company_name}"`
    : 'this contractor';

  return (
    <Modal isOpen={open} toggle={onClose} className="miui-dialog">
      <ModalHeader toggle={onClose}>Delete Contractor</ModalHeader>

      <ModalBody>
        <p className="mb-0">
          Are you sure you want to delete the contractor {companyDisplay}?
          <br />
          This action cannot be undone.
        </p>

        {contractor?.category && (
          <small className="text-muted d-block mt-2">
            Category: {contractor.category.toUpperCase()}
          </small>
        )}

        {contractor?.property_details?.building_name && (
          <small className="text-muted d-block">
            Linked to: {contractor.property_details.building_name}
          </small>
        )}
      </ModalBody>

      <ModalFooter>
        <Button
          outline
          color="secondary"
          className="miui-button"
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </Button>

        <Button
          color="danger"
          className="miui-button"
          onClick={handleConfirm}
          disabled={loading}
        >
          {loading && <Spinner size="sm" className="me-1" />}
          Delete Contractor
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export { DeleteContractorConfirmationModal };